
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { AssessmentAnswers } from '@/types/assessment';
import { categoryExplanations } from '@/data/AIDigitalTransformationData';
import { categoryExplanations as learningCategoryExplanations } from '@/data/AITrainingTransformationData';

interface Question {
  id: number;
  question: string;
  responses: string[];
  category: string;
}

interface AssessmentProfileProps {
  questions: Question[];
  answers: AssessmentAnswers;
  onAnswerChange: (questionId: number, answer: string) => void;
  assessmentType?: 'ia-diagnostic' | 'training-transformation';
}

export const AssessmentProfile: React.FC<AssessmentProfileProps> = ({
  questions,
  answers,
  onAnswerChange,
  assessmentType = 'ia-diagnostic'
}) => {
  // Récupérer l'explication pour "Profil entreprise" selon le type d'audit
  const explanation = assessmentType === 'training-transformation' 
    ? learningCategoryExplanations["Profil entreprise"]
    : categoryExplanations["Profil entreprise"];

  return (
    <div className="w-full max-w-full overflow-hidden">
      <div className="text-center px-2 md:px-4">
        <h2 className="text-xl md:text-2xl font-bold mb-4" style={{ color: '#D7398B' }}>
          Profil de votre entreprise
        </h2>
        {explanation && (
          <div 
            className="mx-auto max-w-full md:max-w-3xl mb-6 px-3 md:px-4 py-3 rounded-lg text-black italic text-sm md:text-base"
            style={{ backgroundColor: 'rgba(255, 102, 0, 0.1)' }}
          >
            {explanation}
          </div>
        )}
      </div>

      <div className="space-y-4 md:space-y-6 px-2 md:px-0">
        {questions.map((question) => (
          <Card key={question.id} className="border-2 border-gray-100 w-full max-w-full">
            <CardContent className="p-4 md:p-6">
              <div className="space-y-3 md:space-y-4">
                <h3 className="font-semibold text-base md:text-lg text-gray-800 break-words">
                  {question.question}
                </h3>
                
                <Select
                  value={answers[question.id] as string || ''}
                  onValueChange={(value) => onAnswerChange(question.id, value)}
                >
                  <SelectTrigger className="w-full border-2 border-gray-200 focus:border-[#D7398B] data-[state=open]:border-[#D7398B] rounded-full text-sm md:text-base">
                    <SelectValue placeholder="Sélectionnez une réponse" />
                  </SelectTrigger>
                  <SelectContent className="rounded-3xl bg-white border-2 border-gray-200 shadow-lg z-50 max-w-[90vw] w-full">
                    {question.responses.map((response, index) => (
                      <SelectItem key={index} value={response} className="cursor-pointer hover:bg-gray-50 text-sm md:text-base break-words">
                        {response}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
